import {Icon, Layout, Text} from '@eitje/web_components'
import {Colors} from '@eitje/assets'

const COLOR_MAP = {
	active: 'green',
	demo: 'green',
	inactive: 'darkGrey',
	out_of_service: 'red',
	expired: 'red',
	eitje: 'blue',
}

export const UserEnvironmentStatusCell = ({value}) => {
	const color = Colors[COLOR_MAP[value]]
	return (
		<Layout style={{display: 'inline-flex'}}>
			<Icon name="dot" fill={color} size={10} />
			<Text t={`users.environment_status.${value}`} />
		</Layout>
	)
}
